import ICNPJInformation from "../../domain/models/integration-cnpj";
import HelperPhone from "./helper-phone";

export const makeDeveloper = (data: any): any => ({
  name: data?.name,
  email: data?.email,
  cpf: data?.cpf,
  phone: HelperPhone.build(data?.phone),
  address: {
    place: data?.developerStreet,
    number: data?.developerNumber,
    district: data?.developerNeighborhood,
    city: data?.developerCity,
    state: data?.developerState,
    complement: data?.developerComplement,
    zipCode: data?.developerCep,
  },
  stacks: data?.stacks,
  otherStack: data?.otherStack,
});

export const makeCompany = (data: any): any => ({
  address: {
    place: data?.companyStreet,
    number: data?.companyNumber,
    district: data?.companyNeighborhood,
    city: data?.companyCity,
    state: data?.companyState,
    complement: data?.companyComplement,
    zipCode: data?.companyCep,
    tipoLogradouro: data?.tipoLogradouro,
  },
  phone: HelperPhone.build(data?.companyPhone),
  cellPhone: data?.companyMobilePhone ? HelperPhone.build(data?.companyMobilePhone) : undefined,
  culturalIncentive: Boolean(data?.culturalIncentive.length) as true,
  email: data?.companyEmail,
  fantasyName: data?.fantasyName,
  isMei: Boolean(data?.isMei.length),
  municipalRegistration: data?.municipalRegistration?.replaceAll("[^a-zA-Z0-9]", "") || "",
  socialReason: data?.socialReason,
  stateRegistration: data?.stateRegistration,
  taxIncentive: Boolean(data?.taxIncentive.length) as true,
  taxType: data?.taxType,
  especialTaxType: data?.especialTaxType,
  simpleNacional: Boolean(data?.simplesNacional?.length || 0) as true,
  subscriptionNumber: data?.cnpj,
  nfseNacional: Boolean(data?.nfseNacional?.length || 0) as true,
  cnaes: data?.companyActivities?.map((item: ICNPJInformation["atividades"][0]) => ({
    code: item.codigo,
  })) || [],
  cityHall: data?.cityHallLogin || data?.cityHallPassword ? {
    login: data?.cityHallLogin || "",
    password: data?.cityHallPassword || "",
  } : undefined,
});

export const makeCertificate = (data: any, companyId: string): FormData => {
  const formData = new FormData();
  formData.append("company", companyId);
  formData.append("file", data?.certificateFile);
  formData.append("password", data?.certificatePassword);
  formData.append("email", data?.certificateEmail);
  return formData;
};
